// Посилання на користувача в Amplitude за user_id (внутрішній id — той самий, що шлють застосунок і бекенд).
// Шаблон адреси — VITE_AMPLITUDE_USER_URL з місцем `{userId}`; не задано — посилання не показуємо.
export function buildAmplitudeUserUrl(userId: number): string | null {
  const template: string | undefined = import.meta.env.VITE_AMPLITUDE_USER_URL;
  if (!template || !template.includes('{userId}')) return null;
  return template.replace('{userId}', encodeURIComponent(String(userId)));
}
